// import { set } from 'lodash'
import { errorHandler } from '../exports/error_management'
const AWS = require('aws-sdk')

const commands = {
    authUri: "authUri",
    callback: "callback",
    getRealm: "getRealm",
    getHost: "getHost",
    refreshAccessToken: "refreshAccessToken",
    getInvoiceByNumber: "getInvoiceByNumber",
    getDueInvoices: "getDueInvoices",
    getInvoicesByUpdateRange: "getInvoicesByUpdateRange",
    createInvoice: "createInvoice",
    getCompanyInfo: "getCompanyInfo",
    downloadExcel: "downloadExcel",
    disconnect: "disconnect"
}

const state = {
    commands,
    loadingId: null,
    authUri_data: null,
    callback_data: null,
    getRealm_data: null,
    getHost_data: null,
    refreshAccessToken_data: null,
    getInvoiceByNumber_data: null,
    getDueInvoices_data: null,
    getInvoicesByUpdateRange_data: null,
    createInvoice_data: null,
    getCompanyInfo_data: null,
    downloadExcel_data:null,
    disconnect_data: null,
}

const getters = {}

const mutations = {
    set_authUri(state, data) { state.authUri_data = data },
    set_callback(state, data) { state.callback_data = data },
    set_getRealm(state, data) { state.getRealm_data = data },
    set_getHost(state, data) { state.getHost_data = data },
    set_refreshAccessToken(state, data) { state.refreshAccessToken_data = data },
    set_getInvoiceByNumber(state, data) { state.getInvoiceByNumber_data = data },
    set_getDueInvoices(state, data) { state.getDueInvoices_data = data },
    set_getInvoicesByUpdateRange(state, data) { state.getInvoicesByUpdateRange_data = data },
    set_createInvoice(state, data) { state.createInvoice_data = data },
    set_getCompanyInfo(state, data) { state.getCompanyInfo_data = data },
    set_downloadExcel(state, data) { state.downloadExcel_data = data },
    set_disconnect(state, data) { state.disconnect_data = data },
}

const actions = {
    async queryQuickbook({ dispatch, commit, state, rootState, rootGetters }, { ams_request, cmd }) {
        try {
            state.loadingId = cmd
            const FunctionName = `arn:aws:lambda:us-east-1:481228531267:function:QuickBookLambdaStack-QuickBookLambdaFunction-NxtBKEyaJLNd${rootGetters.is_development ? '' : ':PROD'}`
            await dispatch('js_report/fetchCredentials', {}, { root: true })

            const {
                key: accessKeyId,
                secret: secretAccessKey,
                token: sessionToken,
                region,
            } = rootState.js_report.aws_credentials

            const options = {
                region,
                accessKeyId,
                secretAccessKey,
                sessionToken,
            }

            AWS.config.update(options)
            const lambda = new AWS.Lambda()

            const { hostname: host } = new URL(rootGetters.baseURL)
            console.log("quickbook cmd:", cmd)
            console.log("quickbook host:", host)

            ams_request = ams_request || {};
            ams_request.host = host
            const Payload = JSON.stringify({
                ams_request, cmd
            })

            const params = {
                FunctionName,
                Payload,
            }

            const { Payload: resp } = await lambda.invoke(params).promise()

            const { statusCode, body } = JSON.parse(resp);

            if (statusCode != 200) throw new Error(body)

            const setData = `set_${cmd}`;
            console.log(setData);
            if (typeof body == 'string') {
                console.log("text received")
            } else if (typeof body == 'object') {
                console.log("object received")
            }
            commit(setData, body);
        } catch (err) {
            errorHandler(err)
        } finally {
            state.loadingId = null
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}